import { animate, style, keyframes, trigger, state, transition } from '@angular/animations';

// animations adapted from animate.css

export let fadeIn = animate(900, keyframes([
  style({opacity: '0', offset: 0}),
  style({opacity: '1', offset: 1})
]));

export let fadeOut = animate(900, keyframes([
  style({opacity: '1', offset: 0}),
  style({opacity: '0', offset: 1})
]));

export let visibilityFadeTrigger = trigger('visibilityFade', [
  state('visible', style({opacity: 1})),
  state('hidden', style({opacity: 0})),
  transition('hidden <=> visible', animate(450))
]);

export let bounce = animate('900ms cubic-bezier(0.215, 0.610, 0.355, 1.000)', keyframes([
  style({transform: 'translate3d(0,0,0)', offset: 0}),
  style({transform: 'translate3d(0,0,0)', offset: 0.2}),
  style({transform: 'translate3d(0,-30px,0)', offset: 0.4}),
  style({transform: 'translate3d(0,-30px,0)', offset: 0.43}),
  style({transform: 'translate3d(0,0,0)', offset: 0.53}),
  style({transform: 'translate3d(0,-15px,0)', offset: 0.7}),
  style({transform: 'translate3d(0,0,0)', offset: 0.8}),
  style({transform: 'translate3d(0,-15px,0)', offset: 0.9}),
  style({transform: 'translate3d(0,0,0)', offset: 1})
]));

export let zoomIn = animate(900, keyframes([
  style({transform: 'scale3d(.3, .3, .3)', opacity: '0', offset: 0}),
  style({transform: 'none', opacity: '1', offset: 1})
]));

export let zoomOut = animate(900, keyframes([
  style({transform: 'none', opacity: '1', offset: 0}),
  style({transform: 'scale3d(.3, .3, .3)  ', opacity: '0', offset: 1})
]));
